export default __webpack_public_path__ + "static/media/kanye4.98eceb7f.jpeg";